function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.981 8.983c0 .11-.03.211-.063.31v8.752c0 1.03-.841 1.875-1.872 1.875H2.943a1.882 1.882 0 0 1-1.873-1.875V9.39a.99.99 0 0 1-.091-.407c0-.145.035-.281.091-.406V1.92C1.07.889 1.915.045 2.943.045h16.103c1.031 0 1.872.844 1.872 1.875v6.753c.033.099.063.2.063.31zm-1.935 9.062V9.983H2.943v8.062h16.103zM2.943 1.92v6.063h16.103V1.92H2.943zM8.98 5.984h-3a1.001 1.001 0 0 1 0-2.001h3a1 1 0 0 1 0 2.001zm-3 5.999h10.001a1.001 1.001 0 0 1 0 2H5.98a1 1 0 0 1 0-2z"
});

var SvgCard = function SvgCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/card.ff8bdc04.svg";
export { ForwardRef as ReactComponent };